import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};

  margin: ${({ theme }) =>
    `${theme.spacing(4)} ${theme.spacing(6)} ${theme.spacing(1)}`};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const IconButtonContainer = styled.span`
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;

export const ChildrenContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing(1.5)};
`;
